// Import Dependencies
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

// Import Image
import Logo from '../../../../web/images/svg/logo-calendar.svg';

// Import Utils
import { getClassNames, isMediaMatched } from '../../../utils';

const Header = ({
  heading, ...props
}) => {
  const calendarContainer = document.querySelector('.js-calendar');
  const calendarInner = document.querySelector('.js-calendar-inner');
  const mediaQuery = isMediaMatched(1200);
  const headerRef = useRef(null);

  useEffect(() => {
    const setStickyHeader = () => {
      const headerOffsetTop = headerRef.current.getBoundingClientRect().top;

      if (headerOffsetTop === 0) {
        calendarContainer.classList.add('has-sticky-header');
      } else {
        calendarContainer.classList.remove('has-sticky-header');
      }
    };

    if (!mediaQuery) {
      calendarInner.addEventListener('scroll', setStickyHeader);
    }
  }, [calendarInner, calendarContainer.classList, mediaQuery, headerRef]);

  return (
    <header ref={headerRef} className={getClassNames(props, 'c-calendar__header', {})}>
      <div className="c-calendar__logo"><Logo /></div>
      <h1 className="c-calendar__heading">{heading}</h1>
    </header>
  );
};

Header.propTypes = {
  heading: PropTypes.string.isRequired,
};

export default Header;
